export const queryConstants = {
  // 士業情報
  SPECIALISTS: "specialists",
  // 士業のクライエント一覧情報
  CLIENTS_LIST: "clients_list",
  // クライエント情報
  CLIENTS: "clients",
};
